export default __webpack_public_path__ + "0a6c0ceac6aba542bc2af25a72de6485.png";